import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../environments/environment'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { DTOAdapter } from './DTOs/DTOAdapter'
import { ProductLibrary } from '../domain/ProductLibrary'
import { ProductLibraryDTO } from './DTOs/ProductLibraryDTO'

@Injectable({
    providedIn: 'root'
})
export class ProductLibraryService {

    constructor(
        private http: HttpClient,
        private dtoAdapter: DTOAdapter
    ) {}

    getForVenueId(venueId: string): Observable<ProductLibrary> {
        const path = `/product-library/venue/${venueId}`
        const url = new URL(path, environment.apiBaseUrl)
        return this.http.get<ProductLibraryDTO>(url.toString())
            .pipe(map(dto => this.dtoAdapter.adaptProductLibraryDto(dto)))
    }
}
